import React, { type Ref } from 'react';

import Button from '@atlaskit/button/default/button';
import { ModalContextProvider } from '@atlassian/entry-points/modal-context-provider';
import { ModalTrigger } from '@atlassian/entry-points/modal-trigger';

import { modalEntryPoint } from '../fixtures/modal-entry-point';
import { RelayWrapper } from '../utils/wrapper';

export default function ModalTriggerBasic(): React.JSX.Element {
	return (
		<RelayWrapper>
			<ModalContextProvider>
				<ModalTrigger
					entryPoint={modalEntryPoint}
					title="Example Modal"
					loadingText="Loading example modal"
				>
					{({ ref }) => (
						<Button ref={ref as Ref<HTMLButtonElement>} aria-haspopup="dialog">
							Open modal
						</Button>
					)}
				</ModalTrigger>
			</ModalContextProvider>
		</RelayWrapper>
	);
}
